export const MUSIC_MUSEUM_SEAT_PLANS = {
  "Orchestra": {
    label: "Orchestra",
    pages: [
      {
        id: "a",
        label: "A",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
        columns: 17,
        layout: [
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0],
          [0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ],
        description: "Orchestra A seating layout for Music Museum with an aisle between columns 12 and 13.",
      },
      {
        id: "h",
        label: "H",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
        columns: 14,
        layout: [
          [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0],
          [1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0],
          [0, 0, 1, 1, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0],
          [0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ],
        description: "Orchestra H seating layout. Space between column 4 and rest.",
      },
    ],
    description: "Orchestra seating layout for Music Museum (paginated A and H).",
  },
  VIP: {
    label: "VIP",
    pages: [
      {
        id: "b",
        label: "B",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
        columns: 6,
        layout: [
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
        ],
        description: "VIP SECTION B",
      },
      {
        id: "c",
        label: "C",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"],
        columns: 6,
        layout: [
          [0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1],
        ],
        description: "VIP SECTION C",
      },
      {
        id: "d",
        label: "D",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
        columns: 6,
        layout: [
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
        ],
        description: "VIP SECTION D",
      },
      {
        id: "e",
        label: "E",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
        columns: 6,
        layout: [
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
        ],
        description: "VIP SECTION E",
      },
      {
        id: "f",
        label: "F",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"],
        columns: 6,
        layout: [
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
        ],
        description: "VIP SECTION F",
      },
      {
        id: "g",
        label: "G",
        rows: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
        columns: 6,
        layout: [
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1],
          [0, 0, 0, 0, 1, 1],
        ],
        description: "VIP SECTION G",
      },
    ],
    description: "VIP seating layout for Music Museum (paginated B-G sections).",
  },
  Balcony: {
    label: "Balcony",
    pages: [
      {
        id: "left",
        label: "Left",
        rows: ["A", "B", "C", "D", "E", "F"],
        columns: 20,
        layout: [
          [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 1, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        ],
        description: "Balcony Left. Spaces between columns 6-7, 9-10, and 10-11.",
      },
      {
        id: "center",
        label: "Center",
        rows: ["D", "E", "F", "", "G"],
        columns: 24,
        layout: [
          [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0],
          [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0],
          [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1],
        ],
        description: "Balcony Center. Really big space between columns 12 and 13, plus a row gap between F and G.",
      },
      {
        id: "right",
        label: "Right",
        rows: ["A", "B", "C", "D", "E", "F", "", "G"],
        columns: 21,
        layout: [
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1],
          [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1],
          [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1],
          [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
        ],
        description: "Balcony Right. Space between rows F and G. Spaces between columns 10-11 (except F), 13-14, and 14-16.",
      },
    ],
    description: "Balcony seating layout for Music Museum split into paged sections.",
  },
};

const computeRowSeatCounts = (plan, rows) => {
  if (Array.isArray(plan.layout)) {
    return plan.layout.reduce((counts, row, index) => ({
      ...counts,
      [rows[index]]: row.filter(Boolean).length,
    }), {});
  }

  if (Array.isArray(plan.pages)) {
    return plan.pages.reduce((counts, page) => {
      page.rows.forEach((rowLabel, index) => {
        const seatCount = page.layout?.[index]?.filter(Boolean).length ?? page.columns ?? 0;
        counts[rowLabel] = Math.max(counts[rowLabel] || 0, seatCount);
      });
      return counts;
    }, {});
  }

  return rows.reduce((counts, row) => ({ ...counts, [row]: 0 }), {});
};

export const MUSIC_MUSEUM_SECTION_LAYOUTS = Object.fromEntries(
  Object.entries(MUSIC_MUSEUM_SEAT_PLANS).map(([key, plan]) => [
    key,
    {
      rows: plan.rows,
      rowSeatCounts: computeRowSeatCounts(plan, plan.rows),
      pages: plan.pages,
      description: plan.description,
    },
  ])
);
